module.exports = __webpack_public_path__ + "img/icon_bdgd.00b9c553.png";